import React from "react";
import { Dialog, Flex, Text, TextField, Button } from "@radix-ui/themes";
import { ArrowTopRightOnSquareIcon } from "@heroicons/react/24/solid";

export function AuthComoDialog({
  isOpen,
  onOpenChange,
  onCancel,
  onSave,
  handleApiKeyChange,
  isApiKeyValid,
  isLoading,
  primaryIdentifier,
  setPrimaryIdentifier,
  identifierError,
  title = "Connect Como",
}) {
  return (
    <Dialog.Root open={isOpen} onOpenChange={onOpenChange}>
      <Dialog.Content maxWidth="600px" maxHeight="690px" align="center">
        <Dialog.Title>{title}</Dialog.Title>
        <Dialog.Description size="2" mb="4">
          If you can't find your API key, please ask Como customer support for assistance.
        </Dialog.Description>

        <Flex
          className="slot-container"
          style={{ alignSelf: "stretch" }}
          display="flex"
          direction="row"
          align="start"
          gap="5"
        >
          <Flex
            className="api-key-field"
            style={{ flex: 1 }}
            display="flex"
            direction="column"
            align="start"
            gap="1"
          >
            <Text size="2" weight="medium">
              API key
            </Text>
            <TextField.Root
              onChange={handleApiKeyChange}
              placeholder="Paste your Como API key here"
              style={{ width: "100%" }}
              size="2"
              variant="surface"
            />
            {!isApiKeyValid && (
              <Text size="1" weight="regular" color="red">
                Please enter a valid API key.
              </Text>
            )}
          </Flex>
        </Flex>

        <Flex direction="column" align="start" gap="2" style={{ marginTop: "16px" }}>
          <Text size="2" weight="medium" style={{ marginBottom: "-5px" }}>
            Primary Identifier
          </Text>

          <Text size="1" color="gray">
            We will enable this identifier for you automatically on all your captive portals. If a captive portal is already using four fields, please remove one so we can continue. Or, you can click “Connect” to check your setup - if something needs attention, you will see a popup with instructions.
          </Text>

          <Flex gap="3">
            <Button
              variant={primaryIdentifier === "email" ? "solid" : "outline"}
              onClick={() => setPrimaryIdentifier("email")}
              size="2"
            >
              Email
            </Button>
            <Button
              variant={primaryIdentifier === "phone" ? "solid" : "outline"}
              onClick={() => setPrimaryIdentifier("phone")}
              size="2"
            >
              Phone
            </Button>
          </Flex>

          {identifierError && (
            <Text size="1" color="red">
              Please select Email or Phone.
            </Text>
          )}
        </Flex>

        <Flex
          style={{
            alignSelf: "stretch",
            width: "100%",
          }}
          display="flex"
          justify="between"
          align="center"
          mt="4"
        >
          <Button
            size="2"
            variant="ghost"
            color="gray"
            onClick={() =>
              window.open("https://www.comosense.com/contact-us/", "_blank")
            }
          >
            <Flex display="flex" align="center" gap="2">
              Contact Como Support
              <ArrowTopRightOnSquareIcon
                style={{ width: "16px", height: "16px" }}
              />
            </Flex>
          </Button>

          <Flex display="flex" gap="3" justify="end">
            <Dialog.Close>
              <Button onClick={onCancel} size="2" variant="soft" color="gray">
                Cancel
              </Button>
            </Dialog.Close>
            <Button
              onClick={() => onSave()}
              size="2"
              variant="soft"
              color="accent"
              loading={isLoading}
            >
              Connect
            </Button>
          </Flex>
        </Flex>
      </Dialog.Content>
    </Dialog.Root>
  );
}
